export const SET_VALID_FIELD = "SET_VALID_FIELD";
export const REMOVE_VALID_FIELD = "REMOVE_VALID_FIELD";
export const SET_INVALID_FIELD = "SET_INVALID_FIELD";
export const REMOVE_INVALID_FIELD = "REMOVE_INVALID_FIELD";
export const REMOVE_FIELDS_CORRECTNESS = "REMOVE_FIELDS_CORRECTNESS";
